import OrderMethodModal from './OrderMethodModal';
import OrderMethodToolbar from './OrderMethodToolbar';
import SegmentContents from './SegmentContents';

export default {
  OrderMethodToolbar,
  OrderMethodModal,
  SegmentContents,
};
